import api from './api';

export const downloadFloorplanEmployees = async (): Promise<void> => {
  // Axios rejects HTTP errors before a download can disguise them as a CSV.
  const { data } = await api.get<Blob>('/employees/export/floorplan', { responseType: 'blob' });
  const url = URL.createObjectURL(data);
  const anchor = document.createElement('a');
  try {
    anchor.href = url;
    anchor.download = 'attendance_floorplan_employees.csv';
    document.body.appendChild(anchor);
    anchor.click();
  } finally {
    anchor.remove();
    URL.revokeObjectURL(url);
  }
};
